const DIRECTIVE_NAME = 'ktTravellerProfileEmailExistence';

export default function TravellerProfileEmailExistence(
    tripAPI
) {
    'ngInject';
    return {
        restrict: 'A',
        scope: {
            isEmailDuplicated: `=${DIRECTIVE_NAME}`,
            doesTravellerProfileExist: `=${DIRECTIVE_NAME}DoesTravellerProfileExist`,
        },
        require: 'ngModel',
        link: function($scope, elem, attrs, ngModel) {
            $scope.$watch(() => ngModel.$modelValue, (newValue) => {
                if (newValue && !$scope.doesTravellerProfileExist) {
                    tripAPI.isEmailExists(newValue)
                        .then(({IsEmailExist}) => $scope.isEmailDuplicated = IsEmailExist);
                }
                $scope.isEmailDuplicated = false;
            });
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/travellers/adult/traveller-profile-email-existence-directive.js